import React from 'react';

const MongoDB_project = () => {
  return (
    <div>
      <h1>MongoDB_project Component</h1>
      <p>This is the MongoDB_project page.</p>
    </div>
  );
};

export default MongoDB_project;
